<button mat-button mat-icon-button aria-label="Help Icon" class="helpicon" (click)="openDialog()">
  <mat-icon>info_outline</mat-icon>
</button>